import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { selectBillingAccount } from './selectBillingAccount'

export const selectUpcomingInvoice = createSelector(
  selectBillingAccount,
  billingAccount => billingAccount.upcomingInvoice || emptyObj
)
